import Head from "next/head";
import environment from "../environments/environment.production";

type Props = {
  title: string;
  content: string;
  pageSlug: string;
  pageType?: string;
  ogImage?: string;
};

export default function CustomHead({
  title,
  content,
  pageSlug,
  pageType = "website",
  ogImage,
}: Props) {
  const ogTitle = title.replace(" - Alamin Shaikh", "");
  const pageURL = `${environment.NEXT_BASE_URL}${pageSlug}`;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={content} />
      <link rel="canonical" href={pageURL} />
      <meta property="og:type" content={pageType} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={content} />
      <meta property="og:url" content={pageURL} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={content} />
    </Head>
  );
}
